// extracted by mini-css-extract-plugin
export default {"wrapper-container":"TextAlignInput_wrapper-container__OVeT4","button-item":"TextAlignInput_button-item__T61lK"};